export default "__VITE_ASSET__V$D9I4jS__"